import { combineReducers } from 'redux';
import appViewSlice from '../app/store/appViewSlice';
import { Reducer } from '@reduxjs/toolkit';
import { RouterState } from 'redux-first-history';
import dashboardViewSlice from '../routes/Dashboard/store/dashboardViewSlice';
import routingSlice from '../app/store/routingSlice';
import apiSlice from 'src/api/store/apiSlice';
import receiptsViewSlice from 'src/routes/Receipts/store/receiptsViewSlice';
import settingsViewSlice from 'src/routes/Settings/store/settingsViewSlice';
import inboxViewSlice from 'src/routes/Inbox/store/inboxViewSlice';
import detailsDrawerSlice from 'src/DetailsDrawer/store/detailsDrawerSlice';
import reportsViewSlice from 'src/routes/Reports/store/reportsViewSlice';

const basicReducers = {
  widgets: apiSlice,
  routing: routingSlice,
  appView: appViewSlice,
  detailsDrawer: detailsDrawerSlice,
  dashboardView: dashboardViewSlice,
  receiptsView: receiptsViewSlice,
  inboxView: inboxViewSlice,
  settingsView: settingsViewSlice,
  reportsView: reportsViewSlice,
};

const createRootReducer = (routerReducer: Reducer<RouterState>) => ({
  ...basicReducers,
  router: routerReducer,
});

export const rootReducerType = combineReducers(basicReducers);
export default createRootReducer;
